/* EVOCELIA motion engine — reveal / word stagger / hero video controls / newsletter restore.
   No dependencies. Transform + opacity only. Honours prefers-reduced-motion.
   Re-initialises on shopify:section:load so the theme editor stays live. */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');

  function each(root, sel, fn) {
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn);
  }

  /* ---- reveal ------------------------------------------------------------ */
  var revealed = [];
  function markIn(n) {
    n.classList.add('is-in');
    var kids = n.querySelectorAll('.ev-r');
    Array.prototype.forEach.call(kids, function (c, i) {
      if (!c.style.getPropertyValue('--i')) c.style.setProperty('--i', i);
      c.classList.add('is-in');
    });
    if (n.classList.contains('ev-r')) n.classList.add('is-in');
  }
  function reveal(root) {
    var nodes = (root || document).querySelectorAll('[data-ev-reveal]');
    if (!nodes.length) return;
    if (RM.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, markIn);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.top >= 0) return;
        markIn(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(nodes, function (n) {
      if (revealed.indexOf(n) !== -1) return;
      revealed.push(n);
      io.observe(n);
    });
  }
  var sweeping = false;
  function sweep() {
    if (sweeping) return;
    sweeping = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      for (var i = 0; i < revealed.length; i++) {
        var n = revealed[i];
        if (n.classList.contains('is-in')) continue;
        var r = n.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0 || r.bottom < 0) markIn(n);
      }
      sweeping = false;
    });
  }

  /* ---- word stagger on the hero H1 ---------------------------------------- */
  function words(root) {
    each(root, '[data-ev-words]', function (h) {
      if (h.dataset.evWordsDone || RM.matches) return;
      h.dataset.evWordsDone = '1';
      var frag = document.createDocumentFragment(), idx = 0;
      Array.prototype.slice.call(h.childNodes).forEach(function (node) {
        if (node.nodeType === 3) {
          node.textContent.split(/(\s+)/).forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
            var s = document.createElement('span');
            s.className = 'ev-word ev-r';
            s.style.setProperty('--i', idx++);
            s.setAttribute('aria-hidden', 'true');
            s.textContent = t;
            frag.appendChild(s);
          });
        } else if (node.nodeType === 1 && node.tagName === 'BR') {
          frag.appendChild(node.cloneNode());
        } else if (node.nodeType === 1) {
          node.classList.add('ev-r', 'ev-word');
          node.style.setProperty('--i', idx++);
          node.setAttribute('aria-hidden', 'true');
          frag.appendChild(node);
        }
      });
      h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
      while (h.firstChild) h.removeChild(h.firstChild);
      h.appendChild(frag);
      h.classList.remove('ev-r');
    });
  }

  /* ---- hero video: play / pause pill + reduced-motion hold ---------------- */
  function video(root) {
    each(root, '[data-ev-video]', function (sec) {
      if (sec.dataset.evVideoDone) return;
      sec.dataset.evVideoDone = '1';
      var v = sec.querySelector('video');
      var btn = sec.querySelector('[data-ev-video-toggle]');
      var label = sec.querySelector('[data-ev-video-label]');
      if (!v) return;
      var onLabel = btn ? btn.getAttribute('data-label-on') : 'AUTOPLAY ON';
      var offLabel = btn ? btn.getAttribute('data-label-off') : 'PAUSED';
      var endLabel = (btn && btn.getAttribute('data-label-ended')) || offLabel;
      function paint() {
        var playing = !v.paused && !v.ended;
        sec.classList.toggle('is-playing', playing);
        sec.classList.toggle('is-ended', !!v.ended);
        if (label) label.textContent = playing ? onLabel : (v.ended ? endLabel : offLabel);
        if (btn) btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      }
      if (RM.matches) { try { v.pause(); } catch (e) {} v.removeAttribute('autoplay'); }
      else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      if (btn) btn.addEventListener('click', function () {
        if (v.paused || v.ended) {
          if (v.ended) { try { v.currentTime = 0; } catch (e) {} }
          var q = v.play(); if (q && q.catch) q.catch(function () {});
        } else v.pause();
      });
      v.addEventListener('play', paint); v.addEventListener('pause', paint); v.addEventListener('ended', paint);
      paint();
    });
  }

  /* ---- newsletter: restore the success state after the native POST -------- */
  function newsletter(root) {
    if (!/customer_posted=true/.test(location.search)) return;
    each(root, '[data-ev-newsletter]', function (f) {
      f.classList.add('is-done');
      var el = document.getElementById(f.id);
      if (el && el.scrollIntoView && !RM.matches) el.scrollIntoView({ block: 'center' });
    });
  }

  function init(root) {
    words(root); reveal(root); video(root); newsletter(root);
    sweep();
  }
  function boot() {
    init(document);
    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
